import React from "react"
import PropTypes from "prop-types"

import moment from "moment"
import { useTranslation } from "react-i18next"
import { numberToCurrency } from "helpers/string"

import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import { Tooltip } from "antd"
import Icon from "components/common/Icon"

TotalBookingValue.propTypes = {
  params: PropTypes.shape({
    overview_range: PropTypes.string.isRequired,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired
}

export default function TotalBookingValue({ params }) {
  const { t } = useTranslation()
  const metadata = useSelector(metadataSelector("accounting"))
  const { bookings_stats } = metadata

  const totalForDates = {
    current_month: moment().format("MMMM YYYY"),
    last_month: moment().subtract(1, "months").format("MMMM YYYY"),
    last_30_days: `${moment().subtract(30, "days").format("MMM DD, YYYY")} — ${moment().format("MMM DD, YYYY")}`,
    total_by_scope: `${moment(params.date_gteq).format("MMM DD, YYYY")} — ${moment(params.date_lteq).format("MMM DD, YYYY")}`
  }
  const dates = totalForDates[params.overview_range]

  return (
    <div className="bg-white rounded p-15 h-100 vstack">
      <h3 className="h4 fw-normal mb-10 hstack gap-1">
        {t(`accounting.labels.total_booking_value`)}
        <Tooltip title={t(`accounting.labels.total_booking_value_tooltip`, { dates })}>
          <span style={{ color: "var(--color-primary)" }}><Icon iconName="Info" size={14} block /></span>
        </Tooltip>
      </h3>
      <p className="fs-7 mb-0">{t(`accounting.values.bookings`, { dates })}</p>
      <p className="fw-bold mb-0">{numberToCurrency(bookings_stats[`${params.overview_range}_value`])}</p>
    </div>
  )
}
